export const tranformSource = () => {
  const source = [
    {
      symbol: "AAPL",
      key: "Wearables, Home and Accessories",
      zh: "穿戴式裝置、居家與配件",
    },
    {
      symbol: "AAPL",
      key: "iPhone",
      zh: "iPhone收入",
    },
    {
      symbol: "AAPL",
      key: "Mac",
      zh: "Mac收入",
    },
    {
      symbol: "AAPL",
      key: "iPad",
      zh: "iPad收入",
    },
    {
      symbol: "AAPL",
      key: "Services",
      zh: "服務收入",
    },
    {
      symbol: "ABBV",
      key: "Immunology",
      zh: "免疫學藥收入",
    },
    {
      symbol: "ABBV",
      key: "Oncology",
      zh: "腫瘤學藥收入",
    },
    {
      symbol: "ABBV",
      key: "Aesthetics",
      zh: "醫學美容收入",
    },
    {
      symbol: "ABBV",
      key: "Neuroscience",
      zh: "神經科學收入",
    },
    {
      symbol: "ADBE",
      key: "Subscription",
      zh: "訂閱收入",
    },
    {
      symbol: "ADBE",
      key: "Product",
      zh: "產品收入",
    },
    {
      symbol: "ADBE",
      key: "Services and other",
      zh: "服務與其他收入",
    },
    {
      symbol: "AFRM",
      key: "Total network revenue",
      zh: "總體網路收入",
    },
    {
      symbol: "AFRM",
      key: "Interest income",
      zh: "利息收入",
    },
    {
      symbol: "AFRM",
      key: "Gain on sales of loans",
      zh: "貸款銷售收益",
    },
    {
      symbol: "AFRM",
      key: "Servicing income",
      zh: "服務收入",
    },
    {
      symbol: "AI",
      key: "Subscription",
      zh: "訂閱收入",
    },
    {
      symbol: "AI",
      key: "Professional services",
      zh: "專業服務",
    },
    {
      symbol: "AMD",
      key: "Computing and Graphics",
      zh: "運算與繪圖收入",
    },
    {
      symbol: "AMD",
      key: "Enterprise, Embedded and Semi-Custom",
      zh: "企業、嵌入式與半客製化收入",
    },
    {
      symbol: "AMD",
      key: "Xilinx",
      zh: "Xilinx收入",
    },
    {
      symbol: "AMD",
      key: "Data Center",
      zh: "資料中心收入",
    },
    {
      symbol: "AMD",
      key: "Client",
      zh: "用戶端收入",
    },
    {
      symbol: "AMD",
      key: "Gaming",
      zh: "遊戲收入",
    },
    {
      symbol: "AMD",
      key: "Embedded",
      zh: "嵌入式收入",
    },
    {
      symbol: "AMZN",
      key: "Online stores",
      zh: "線上商店收入",
    },
    {
      symbol: "AMZN",
      key: "Physical stores",
      zh: "實體商店收入",
    },
    {
      symbol: "AMZN",
      key: "Third-party seller services",
      zh: "第三方賣家服務收入",
    },
    {
      symbol: "AMZN",
      key: "Subscription services",
      zh: "訂閱服務收入",
    },
    {
      symbol: "AMZN",
      key: "AWS",
      zh: "AWS收入",
    },
    {
      symbol: "AMZN",
      key: "Other",
      zh: "其他收入",
    },
    {
      symbol: "AMZN",
      key: "Advertising services",
      zh: "廣告服務收入",
    },
    {
      symbol: "ANET",
      key: "Product",
      zh: "產品",
    },
    {
      symbol: "ANET",
      key: "Service",
      zh: "服務",
    },
    {
      symbol: "AVGO",
      key: "Semiconductor solutions",
      zh: "半導體解決方案收入",
    },
    {
      symbol: "AVGO",
      key: "Infrastructure software",
      zh: "基礎設施軟體收入",
    },
    {
      symbol: "BAC",
      key: "Merrill Wealth Management",
      zh: "Merrill 財富管理",
    },
    {
      symbol: "BAC",
      key: "Bank of America Private Bank",
      zh: "美國銀行私人銀行",
    },
    {
      symbol: "C",
      key: "Legacy Franchises",
      zh: "非核心部門業務",
    },
    {
      symbol: "C",
      key: "Global Consumer Banking",
      zh: "全球消費銀行",
    },
    {
      symbol: "C",
      key: "Institutional Clients Group",
      zh: "機構客戶集團",
    },
    {
      symbol: "C",
      key: "Corporate/Other",
      zh: "企業/其他",
    },
    {
      symbol: "C",
      key: "Personal Banking and Wealth Management",
      zh: "個人銀行與財富管理",
    },
    {
      symbol: "C",
      key: "Services",
      zh: "服務",
    },
    {
      symbol: "C",
      key: "Markets",
      zh: "市場",
    },
    {
      symbol: "C",
      key: "Banking",
      zh: "銀行業務",
    },
    {
      symbol: "C",
      key: "USPB",
      zh: "美國個人銀行",
    },
    {
      symbol: "C",
      key: "Wealth",
      zh: "財富管理",
    },
    {
      symbol: "C",
      key: "All Other",
      zh: "所有其他",
    },
    {
      symbol: "C",
      key: "Reconciling Items",
      zh: "調節項目",
    },
    {
      symbol: "CFLT",
      key: "Confluent Platform - License",
      zh: "Confluent 平台 - 授權",
    },
    {
      symbol: "CFLT",
      key: "Confluent Platform - PCS",
      zh: "Confluent 平台 - PCS",
    },
    {
      symbol: "CFLT",
      key: "Confluent Cloud",
      zh: "Confluent 雲端",
    },
    {
      symbol: "CFLT",
      key: "Subscription",
      zh: "訂閱",
    },
    {
      symbol: "CFLT",
      key: "Services",
      zh: "服務",
    },
    {
      symbol: "CLSK",
      key: "Bitcoin mining revenue",
      zh: "比特幣挖礦收入",
    },
    {
      symbol: "CLSK",
      key: "Other services revenue",
      zh: "其他服務收入",
    },
    {
      symbol: "COIN",
      key: "Transaction revenue",
      zh: "交易收入",
    },
    {
      symbol: "COIN",
      key: "Subscription and services revenue",
      zh: "訂閱與服務收入",
    },
    {
      symbol: "COIN",
      key: "Other revenue",
      zh: "其他收入",
    },
    {
      symbol: "COST",
      key: "Warehouse Ancillary and Other Businesses",
      zh: "倉儲輔助設施及其他業務",
    },
    {
      symbol: "COST",
      key: "Foods and Sundries",
      zh: "食品與雜貨收入",
    },
    {
      symbol: "COST",
      key: "Non-Foods",
      zh: "非食品收入",
    },
    {
      symbol: "COST",
      key: "Fresh Foods",
      zh: "生鮮食品收入",
    },
    {
      symbol: "COST",
      key: "Ancillary and Other Businesses",
      zh: "附屬與其他業務收入",
    },
    {
      symbol: "CPNG",
      key: "Net retail sales",
      zh: "淨零售銷售",
    },
    {
      symbol: "CPNG",
      key: "Third-party merchant services",
      zh: "第三方商家服務",
    },
    {
      symbol: "CPNG",
      key: "Other revenue",
      zh: "其他收入",
    },
    {
      symbol: "CRM",
      key: "Sales",
      zh: "銷售收入",
    },
    {
      symbol: "CRM",
      key: "Service",
      zh: "服務收入",
    },
    {
      symbol: "CRM",
      key: "Platform and Other",
      zh: "平台與其他收入",
    },
    {
      symbol: "CRM",
      key: "Marketing and Commerce",
      zh: "行銷與商務收入",
    },
    {
      symbol: "CRM",
      key: "Integration and Analytics",
      zh: "整合與分析收入",
    },
    {
      symbol: "CRM",
      key: "Data",
      zh: "資料收入",
    },
    {
      symbol: "CRWD",
      key: "Subscription",
      zh: "訂閱收入",
    },
    {
      symbol: "CRWD",
      key: "Professional services",
      zh: "專業服務收入",
    },
    {
      symbol: "CSCO",
      key: "Infrastructure Platforms",
      zh: "基礎設施平台",
    },
    {
      symbol: "CSCO",
      key: "Applications",
      zh: "應用程式",
    },
    {
      symbol: "CSCO",
      key: "Security",
      zh: "安全",
    },
    {
      symbol: "CSCO",
      key: "Other Products",
      zh: "其他產品",
    },
    {
      symbol: "CSCO",
      key: "Services",
      zh: "服務",
    },
    {
      symbol: "CSCO",
      key: "Secure, Agile Networks",
      zh: "安全、敏捷網路",
    },
    {
      symbol: "CSCO",
      key: "Hybrid Work",
      zh: "混合工作",
    },
    {
      symbol: "CSCO",
      key: "End-to-End Security",
      zh: "端到端安全",
    },
    {
      symbol: "CSCO",
      key: "Internet for the Future",
      zh: "未來網際網路",
    },
    {
      symbol: "CSCO",
      key: "Optimized Application Experiences",
      zh: "最佳化應用體驗",
    },
    {
      symbol: "CSCO",
      key: "Collaboration",
      zh: "協作",
    },
    {
      symbol: "CSCO",
      key: "Networking",
      zh: "網路",
    },
    {
      symbol: "CSCO",
      key: "Observability",
      zh: "可觀察性",
    },
    {
      symbol: "CVNA",
      key: "Retail vehicle sales, net",
      zh: "零售車輛銷售淨額",
    },
    {
      symbol: "CVNA",
      key: "Wholesale sales and revenues",
      zh: "批發銷售與收入",
    },
    {
      symbol: "CVNA",
      key: "Other sales and revenues",
      zh: "其他銷售與收入",
    },
    {
      symbol: "CVS",
      key: "Pharmacy",
      zh: "藥局",
    },
    {
      symbol: "CVS",
      key: "Front Store",
      zh: "前店",
    },
    {
      symbol: "CVS",
      key: "Premiums",
      zh: "保費",
    },
    {
      symbol: "CVS",
      key: "Net investment income",
      zh: "淨投資收入",
    },
    {
      symbol: "CVS",
      key: "Other",
      zh: "其他",
    },
    {
      symbol: "CVX",
      key: "Upstream",
      zh: "上游",
    },
    {
      symbol: "CVX",
      key: "Downstream",
      zh: "下游",
    },
    {
      symbol: "CVX",
      key: "All Other",
      zh: "所有其他",
    },
    {
      symbol: "DECK",
      key: "UGG brand wholesale",
      zh: "UGG 品牌批發收入",
    },
    {
      symbol: "DECK",
      key: "HOKA brand wholesale",
      zh: "HOKA 品牌批發收入",
    },
    {
      symbol: "DECK",
      key: "Teva brand wholesale",
      zh: "Teva 品牌批發收入",
    },
    {
      symbol: "DECK",
      key: "Sanuk brand wholesale",
      zh: "Sanuk 品牌批發收入",
    },
    {
      symbol: "DECK",
      key: "Other brands wholesale",
      zh: "其他品牌批發收入",
    },
    {
      symbol: "DELL",
      key: "Client Solutions Group",
      zh: "客戶解決方案事業群",
    },
    {
      symbol: "DELL",
      key: "Infrastructure Solutions Group",
      zh: "基礎設施解決方案事業群",
    },
    {
      symbol: "DELL",
      key: "VMware",
      zh: "VMware",
    },
    {
      symbol: "DELL",
      key: "Corporate and Other",
      zh: "企業與其他",
    },
    {
      symbol: "ETN",
      key: "Electrical Americas",
      zh: "美洲電氣",
    },
    {
      symbol: "ETN",
      key: "Electrical Global",
      zh: "全球電氣",
    },
    {
      symbol: "ETN",
      key: "Hydraulics",
      zh: "液壓",
    },
    {
      symbol: "ETN",
      key: "Aerospace",
      zh: "航太",
    },
    {
      symbol: "ETN",
      key: "eMobility",
      zh: "電動移動",
    },
    {
      symbol: "ETN",
      key: "Vehicle",
      zh: "車輛",
    },
    {
      symbol: "F",
      key: "Vehicles, parts, and accessories",
      zh: "車輛、零件與配件",
    },
    {
      symbol: "F",
      key: "Used vehicles",
      zh: "二手車",
    },
    {
      symbol: "F",
      key: "Services and other revenue",
      zh: "服務與其他收入",
    },
    {
      symbol: "F",
      key: "Leasing income",
      zh: "租賃收入",
    },
    {
      symbol: "F",
      key: "Financing income",
      zh: "融資收入",
    },
    {
      symbol: "F",
      key: "Insurance income",
      zh: "保險收入",
    },
    {
      symbol: "FTNT",
      key: "Product",
      zh: "產品",
    },
    {
      symbol: "FTNT",
      key: "Service",
      zh: "服務",
    },
    {
      symbol: "GEN",
      key: "Legacy revenues",
      zh: "傳統業務收入",
    },
    {
      symbol: "GEN",
      key: "Consumer security revenues",
      zh: "消費者安全收入",
    },
    {
      symbol: "GEN",
      key: "Identity and information protection revenues",
      zh: "身份與資訊保護收入",
    },
    {
      symbol: "GOOG",
      key: "Google Services total",
      zh: "Google 服務總計收入",
    },
    {
      symbol: "GOOG",
      key: "Google Cloud",
      zh: "Google 雲端收入",
    },
    {
      symbol: "GOOG",
      key: "Other Bets",
      zh: "其他業務收入",
    },
    {
      symbol: "GOOG",
      key: "Hedging gains (losses)",
      zh: "對沖收益（損失）",
    },
    {
      symbol: "GOOGL",
      key: "Google Search & other",
      zh: "Google 搜尋與其他收入",
    },
    {
      symbol: "GOOGL",
      key: "YouTube ads",
      zh: "YouTube 廣告收入",
    },
    {
      symbol: "GOOGL",
      key: "Google Network",
      zh: "Google 網路收入",
    },
    {
      symbol: "GOOGL",
      key: "Google advertising",
      zh: "Google 廣告收入",
    },
    {
      symbol: "GOOGL",
      key: "Google other",
      zh: "Google 其他收入",
    },
    {
      symbol: "GOOGL",
      key: "Google Services total",
      zh: "Google 服務總計收入",
    },
    {
      symbol: "GOOGL",
      key: "Google Cloud",
      zh: "Google 雲端收入",
    },
    {
      symbol: "GOOGL",
      key: "Other Bets",
      zh: "其他業務收入",
    },
    {
      symbol: "GOOGL",
      key: "Hedging gains (losses)",
      zh: "對沖收益（損失）",
    },
    {
      symbol: "GOOGL",
      key: "Google subscriptions, platforms, and devices",
      zh: "Google 訂閱、平台與裝置收入",
    },
    {
      symbol: "HIMS",
      key: "Online Revenue",
      zh: "線上收入",
    },
    {
      symbol: "HIMS",
      key: "Wholesale Revenue",
      zh: "批發收入",
    },
    {
      symbol: "HOOD",
      key: "Transaction-based revenues",
      zh: "基於交易的收入",
    },
    {
      symbol: "HOOD",
      key: "Net interest revenues",
      zh: "淨利息收入",
    },
    {
      symbol: "HOOD",
      key: "Other revenues",
      zh: "其他收入",
    },
    {
      symbol: "INTC",
      key: "Programmable Solutions Group",
      zh: "可程式化解決方案事業群",
    },
    {
      symbol: "INTC",
      key: "Client Computing Group",
      zh: "用戶端運算事業群",
    },
    {
      symbol: "INTC",
      key: "Non-Volatile Memory Solutions Group",
      zh: "非揮發性記憶體解決方案事業群",
    },
    {
      symbol: "INTC",
      key: "Intersegment Eliminations",
      zh: "部門間消除項目",
    },
    {
      symbol: "INTC",
      key: "Data Center Group",
      zh: "資料中心集團",
    },
    {
      symbol: "INTC",
      key: "Internet of Things",
      zh: "物聯網",
    },
    {
      symbol: "INTC",
      key: "All other",
      zh: "所有其他",
    },
    {
      symbol: "INTC",
      key: "Client Computing",
      zh: "用戶端運算",
    },
    {
      symbol: "INTC",
      key: "Data Center and AI",
      zh: "資料中心與人工智慧",
    },
    {
      symbol: "INTC",
      key: "Network and Edge",
      zh: "網路與邊緣",
    },
    {
      symbol: "INTC",
      key: "Accelerated Computing Systems and Graphics",
      zh: "加速運算系統與繪圖",
    },
    {
      symbol: "INTC",
      key: "Mobileye",
      zh: "Mobileye",
    },
    {
      symbol: "INTC",
      key: "Intel Foundry Services",
      zh: "Intel 代工服務",
    },
    {
      symbol: "INTC",
      key: "Intel Products",
      zh: "Intel 產品",
    },
    {
      symbol: "INTC",
      key: "Intel Foundry",
      zh: "Intel 代工",
    },
    {
      symbol: "KLAC",
      key: "Semiconductor Process Control",
      zh: "半導體製程控制",
    },
    {
      symbol: "KLAC",
      key: "Specialty Semiconductor Process",
      zh: "特殊半導體製程",
    },
    {
      symbol: "KLAC",
      key: "PCB and Component Inspection",
      zh: "印刷電路板與元件檢測",
    },
    {
      symbol: "LLY",
      key: "Diabetes and obesity",
      zh: "糖尿病與肥胖",
    },
    {
      symbol: "LLY",
      key: "Oncology",
      zh: "腫瘤學",
    },
    {
      symbol: "LLY",
      key: "Immunology",
      zh: "免疫學",
    },
    {
      symbol: "LLY",
      key: "Neuroscience",
      zh: "神經科學",
    },
    {
      symbol: "LLY",
      key: "Other",
      zh: "其他",
    },
    {
      symbol: "LLY",
      key: "Cardiometabolic Health",
      zh: "心臟代謝健康",
    },
    {
      symbol: "LULU",
      key: "Women's product",
      zh: "女性產品",
    },
    {
      symbol: "LULU",
      key: "Men's product",
      zh: "男性產品",
    },
    {
      symbol: "LULU",
      key: "Other categories",
      zh: "其他類別",
    },
    {
      symbol: "LYFT",
      key: "Revenue from contracts with customers (ASC 606)",
      zh: "與客戶合約的收入（ASC 606）",
    },
    {
      symbol: "LYFT",
      key: "Rental revenue (ASC 842)",
      zh: "租賃收入（ASC 842）",
    },
    {
      symbol: "MCD",
      key: "Sales by Company-operated restaurants",
      zh: "公司營運餐廳銷售",
    },
    {
      symbol: "MCD",
      key: "Revenues from franchised restaurants",
      zh: "特許經營餐廳收入",
    },
    {
      symbol: "MCD",
      key: "Other revenues",
      zh: "其他收入",
    },
    {
      symbol: "MDB",
      key: "MongoDB Atlas-related",
      zh: "MongoDB Atlas 相關",
    },
    {
      symbol: "MDB",
      key: "Other subscription",
      zh: "其他訂閱",
    },
    {
      symbol: "MDB",
      key: "Services",
      zh: "服務",
    },
    {
      symbol: "META",
      key: "Advertising",
      zh: "廣告收入",
    },
    {
      symbol: "META",
      key: "Other revenue",
      zh: "其他收入",
    },
    {
      symbol: "META",
      key: "Reality Labs",
      zh: "Reality Labs收入",
    },
    {
      symbol: "MRVL",
      key: "Networking",
      zh: "網路收入",
    },
    {
      symbol: "MRVL",
      key: "Storage",
      zh: "儲存收入",
    },
    {
      symbol: "MRVL",
      key: "Other",
      zh: "其他收入",
    },
    {
      symbol: "MRVL",
      key: "Data center",
      zh: "資料中心收入",
    },
    {
      symbol: "MRVL",
      key: "Carrier infrastructure",
      zh: "電信基礎設施收入",
    },
    {
      symbol: "MRVL",
      key: "Enterprise networking",
      zh: "企業網路收入",
    },
    {
      symbol: "MRVL",
      key: "Consumer",
      zh: "消費者收入",
    },
    {
      symbol: "MRVL",
      key: "Automotive/industrial",
      zh: "汽車/工業收入",
    },
    {
      symbol: "MSFT",
      key: "Server products and cloud services",
      zh: "伺服器產品與雲端服務收入",
    },
    {
      symbol: "MSFT",
      key: "Office products and cloud services",
      zh: "Office 產品與雲端服務收入",
    },
    {
      symbol: "MSFT",
      key: "Windows and Devices",
      zh: "Windows 與裝置收入",
    },
    {
      symbol: "MSFT",
      key: "Gaming",
      zh: "遊戲收入",
    },
    {
      symbol: "MSFT",
      key: "LinkedIn",
      zh: "LinkedIn收入",
    },
    {
      symbol: "MSFT",
      key: "Search and news advertising",
      zh: "搜尋與新聞廣告收入",
    },
    {
      symbol: "MSFT",
      key: "Enterprise and partner services",
      zh: "企業與合作夥伴服務收入",
    },
    {
      symbol: "MSFT",
      key: "Other",
      zh: "其他收入",
    },
    {
      symbol: "MSFT",
      key: "Dynamics products and cloud services",
      zh: "Dynamics 產品與雲端服務收入",
    },
    {
      symbol: "MSFT",
      key: "Microsoft 365 Consumer products and cloud services",
      zh: "Microsoft 365 消費者產品與雲端服務收入",
    },
    {
      symbol: "MSTR",
      key: "Product licenses revenues",
      zh: "產品授權收入",
    },
    {
      symbol: "MSTR",
      key: "Subscription services revenues",
      zh: "訂閱服務收入",
    },
    {
      symbol: "MSTR",
      key: "Product support revenues",
      zh: "產品支援收入",
    },
    {
      symbol: "MSTR",
      key: "Other services revenues",
      zh: "其他服務收入",
    },
    {
      symbol: "MU",
      key: "CNBU",
      zh: "CNBU",
    },
    {
      symbol: "MU",
      key: "MBU",
      zh: "MBU",
    },
    {
      symbol: "MU",
      key: "SBU",
      zh: "SBU",
    },
    {
      symbol: "MU",
      key: "EBU",
      zh: "EBU",
    },
    {
      symbol: "MU",
      key: "All Other",
      zh: "所有其他",
    },
    {
      symbol: "NEE",
      key: "FPL",
      zh: "FPL（佛羅里達電力與燈光公司）收入",
    },
    {
      symbol: "NEE",
      key: "Gulf Power",
      zh: "Gulf Power（墨西哥灣電力公司）收入",
    },
    {
      symbol: "NEE",
      key: "NEER",
      zh: "NEER（NextEra Energy Resources）收入",
    },
    {
      symbol: "NEE",
      key: "Corporate and Other",
      zh: "企業與其他收入",
    },
    {
      symbol: "NET",
      key: "Channel partners",
      zh: "通路合作夥伴收入",
    },
    {
      symbol: "NET",
      key: "Direct customers",
      zh: "直接客戶收入",
    },
    {
      symbol: "NFLX",
      key: "Streaming revenues",
      zh: "串流收入",
    },
    {
      symbol: "NFLX",
      key: "DVD revenues",
      zh: "DVD 收入",
    },
    {
      symbol: "NOW",
      key: "Subscription",
      zh: "訂閱收入",
    },
    {
      symbol: "NOW",
      key: "Professional services and other",
      zh: "專業服務與其他收入",
    },
    {
      symbol: "NVDA",
      key: "Data Center",
      zh: "資料中心收入",
    },
    {
      symbol: "NVDA",
      key: "Gaming",
      zh: "遊戲收入",
    },
    {
      symbol: "NVDA",
      key: "Professional Visualization",
      zh: "專業視覺化收入",
    },
    {
      symbol: "NVDA",
      key: "Automotive",
      zh: "汽車收入",
    },
    {
      symbol: "NVDA",
      key: "OEM and Other",
      zh: "原始設備製造商與其他收入",
    },
    {
      symbol: "O",
      key: "Rental (excluding reimbursable)",
      zh: "租賃（不含可報銷）",
    },
    {
      symbol: "O",
      key: "Rental (reimbursable)",
      zh: "租賃（可報銷）",
    },
    {
      symbol: "O",
      key: "Other",
      zh: "其他",
    },
    {
      symbol: "ORCL",
      key: "Cloud services and license support",
      zh: "雲端服務與授權支援",
    },
    {
      symbol: "ORCL",
      key: "Cloud license and on-premise license",
      zh: "雲端授權與本地授權",
    },
    {
      symbol: "ORCL",
      key: "Hardware",
      zh: "硬體",
    },
    {
      symbol: "ORCL",
      key: "Services",
      zh: "服務",
    },
    {
      symbol: "OXY",
      key: "Eliminations",
      zh: "消除項目",
    },
    {
      symbol: "OXY",
      key: "Oil and gas",
      zh: "石油與天然氣",
    },
    {
      symbol: "OXY",
      key: "Chemical",
      zh: "化學",
    },
    {
      symbol: "OXY",
      key: "Midstream and marketing",
      zh: "中游與行銷",
    },
    {
      symbol: "PANW",
      key: "Product",
      zh: "產品",
    },
    {
      symbol: "PANW",
      key: "Subscription and support",
      zh: "訂閱與支援",
    },
    {
      symbol: "PFE",
      key: "Biopharma",
      zh: "生物製藥",
    },
    {
      symbol: "PFE",
      key: "Other business activities",
      zh: "其他業務活動",
    },
    {
      symbol: "PFE",
      key: "Global Biopharmaceuticals Business (Biopharma)",
      zh: "全球生物製藥業務（生物製藥）",
    },
    {
      symbol: "PFE",
      key: "Business Innovation",
      zh: "業務創新",
    },
    {
      symbol: "PFE",
      key: "Product revenues",
      zh: "產品收入",
    },
    {
      symbol: "PFE",
      key: "Alliance revenues",
      zh: "聯盟收入",
    },
    {
      symbol: "PFE",
      key: "Royalty revenues",
      zh: "權利金收入",
    },
    {
      symbol: "PLTR",
      key: "Government",
      zh: "政府收入",
    },
    {
      symbol: "PLTR",
      key: "Commercial",
      zh: "商業收入",
    },
    {
      symbol: "PYPL",
      key: "Revenues from other value added services",
      zh: "其他加值服務收入",
    },
    {
      symbol: "PYPL",
      key: "Transaction revenues",
      zh: "交易收入",
    },
    {
      symbol: "RIOT",
      key: "Bitcoin Mining",
      zh: "比特幣挖礦",
    },
    {
      symbol: "RIOT",
      key: "License fees",
      zh: "授權費",
    },
    {
      symbol: "RIOT",
      key: "Data Center Hosting",
      zh: "資料中心託管",
    },
    {
      symbol: "RIOT",
      key: "Other",
      zh: "其他",
    },
    {
      symbol: "RIOT",
      key: "Engineering",
      zh: "工程",
    },
    {
      symbol: "RKLB",
      key: "Launch Services",
      zh: "發射服務收入",
    },
    {
      symbol: "RKLB",
      key: "Space Systems",
      zh: "太空系統收入",
    },
    {
      symbol: "SIRI",
      key: "Sirius XM Subscriber Revenue",
      zh: "Sirius XM 訂閱收入",
    },
    {
      symbol: "SIRI",
      key: "Sirius XM Advertising Revenue",
      zh: "Sirius XM 廣告收入",
    },
    {
      symbol: "SIRI",
      key: "Sirius XM Equipment Revenue",
      zh: "Sirius XM 設備收入",
    },
    {
      symbol: "SIRI",
      key: "Sirius XM Other Revenue",
      zh: "Sirius XM 其他收入",
    },
    {
      symbol: "SIRI",
      key: "Pandora and Off-platform Subscriber Revenue",
      zh: "Pandora 與非平台訂閱收入",
    },
    {
      symbol: "SMCI",
      key: "Server and storage systems",
      zh: "伺服器與儲存系統收入",
    },
    {
      symbol: "SMCI",
      key: "Subsystems and accessories",
      zh: "子系統與配件收入",
    },
    {
      symbol: "SNOW",
      key: "Product revenue",
      zh: "產品收入",
    },
    {
      symbol: "SNOW",
      key: "Professional services and other revenue",
      zh: "專業服務與其他收入",
    },
    {
      symbol: "SOFI",
      key: "Lending",
      zh: "放貸收入",
    },
    {
      symbol: "SOFI",
      key: "Financial Services",
      zh: "金融服務收入",
    },
    {
      symbol: "SOFI",
      key: "Technology Platform",
      zh: "技術平台收入",
    },
    {
      symbol: "SQ",
      key: "Transaction-based revenue",
      zh: "基於交易的收入",
    },
    {
      symbol: "SQ",
      key: "Subscription and services-based revenue",
      zh: "訂閱與服務收入",
    },
    {
      symbol: "SQ",
      key: "Hardware revenue",
      zh: "硬體收入",
    },
    {
      symbol: "SQ",
      key: "Bitcoin revenue",
      zh: "比特幣收入",
    },
    {
      symbol: "T",
      key: "Wireless service",
      zh: "無線服務",
    },
    {
      symbol: "T",
      key: "Video service",
      zh: "視頻服務",
    },
    {
      symbol: "T",
      key: "Business service",
      zh: "商業服務",
    },
    {
      symbol: "T",
      key: "IP Broadband",
      zh: "IP 寬頻",
    },
    {
      symbol: "T",
      key: "Subscription",
      zh: "訂閱",
    },
    {
      symbol: "T",
      key: "Content",
      zh: "內容",
    },
    {
      symbol: "T",
      key: "Advertising",
      zh: "廣告",
    },
    {
      symbol: "T",
      key: "Legacy voice and data",
      zh: "傳統語音與數據",
    },
    {
      symbol: "T",
      key: "Other",
      zh: "其他",
    },
    {
      symbol: "T",
      key: "Broadband",
      zh: "寬頻",
    },
    {
      symbol: "T",
      key: "Equipment",
      zh: "設備",
    },
    {
      symbol: "TSLA",
      key: "Energy generation and storage",
      zh: "能源生產與儲存",
    },
    {
      symbol: "TSLA",
      key: "Energy generation and storage leasing",
      zh: "能源生產與儲存租賃",
    },
    {
      symbol: "TSLA",
      key: "Energy generation and storage sales",
      zh: "能源生產與儲存銷售",
    },
    {
      symbol: "TSLA",
      key: "Automotive sales",
      zh: "汽車銷售收入",
    },
    {
      symbol: "TSLA",
      key: "Automotive regulatory credits",
      zh: "汽車法規積分收入",
    },
    {
      symbol: "TSLA",
      key: "Services and other",
      zh: "服務與其他收入",
    },
    {
      symbol: "TSLA",
      key: "Automotive leasing",
      zh: "汽車租賃收入",
    },
    {
      symbol: "UBER",
      key: "Mobility revenue",
      zh: "移動收入",
    },
    {
      symbol: "UBER",
      key: "Delivery revenue",
      zh: "外送收入",
    },
    {
      symbol: "UBER",
      key: "Freight revenue",
      zh: "貨運收入",
    },
    {
      symbol: "UPST",
      key: "Platform and referral fees, net",
      zh: "平台與推薦費用淨額",
    },
    {
      symbol: "UPST",
      key: "Servicing and other fees, net",
      zh: "服務與其他費用淨額",
    },
    {
      symbol: "VRT",
      key: "Critical infrastructure & solutions",
      zh: "關鍵基礎設施與解決方案收入",
    },
    {
      symbol: "VRT",
      key: "Integrated rack solutions",
      zh: "整合機架解決方案收入",
    },
    {
      symbol: "VRT",
      key: "Services & spares",
      zh: "服務與備件收入",
    },
    {
      symbol: "VRT",
      key: "Products",
      zh: "產品收入",
    },
    {
      symbol: "VST",
      key: "Revenue from contracts with customers",
      zh: "與客戶合約的收入",
    },
    {
      symbol: "VST",
      key: "Other revenues",
      zh: "其他收入",
    },
    {
      symbol: "VZ",
      key: "Consumer",
      zh: "消費者收入",
    },
    {
      symbol: "VZ",
      key: "Business",
      zh: "商業收入",
    },
    {
      symbol: "VZ",
      key: "Corporate and other",
      zh: "企業與其他收入",
    },
    {
      symbol: "VZ",
      key: "Eliminations",
      zh: "消除項目",
    },
    {
      symbol: "WMT",
      key: "Grocery",
      zh: "雜貨收入",
    },
    {
      symbol: "WMT",
      key: "General merchandise",
      zh: "一般商品收入",
    },
    {
      symbol: "WMT",
      key: "Health and wellness",
      zh: "健康與保健收入",
    },
    {
      symbol: "WMT",
      key: "Other categories",
      zh: "其他類別收入",
    },
    {
      symbol: "XOM",
      key: "Upstream",
      zh: "上游業務收入",
    },
    {
      symbol: "XOM",
      key: "Downstream",
      zh: "下游業務收入",
    },
    {
      symbol: "XOM",
      key: "Chemical",
      zh: "化學品收入",
    },
    {
      symbol: "XOM",
      key: "Corporate and Financing",
      zh: "企業與融資收入",
    },
    {
      symbol: "XOM",
      key: "Energy Products",
      zh: "能源產品收入",
    },
    {
      symbol: "XOM",
      key: "Chemical Products",
      zh: "化學產品收入",
    },
    {
      symbol: "XOM",
      key: "Specialty Products",
      zh: "特殊產品收入",
    },
    {
      symbol: "XOM",
      key: "Revenue from contracts with customers",
      zh: "與客戶合約的收入",
    },
    {
      symbol: "XOM",
      key: "Revenue outside the scope of ASC 606",
      zh: "不在 ASC 606 範疇內的收入",
    },
  ];
  return source.reduce<Record<string, Record<string, string>>>(
    (acc, { symbol, key, zh }) => {
      acc[symbol] = {
        ...acc[symbol],
        [key]: zh,
      };
      return acc;
    },
    {}
  );
};
